import React, { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { Settings, ExternalLink } from "lucide-react";

const PublicLayout = () => {
  const { setPublicTheme } = useTheme();
  const location = useLocation();

  useEffect(() => {
    setPublicTheme();
  }, [setPublicTheme]);

  return (
    <div className="min-h-screen bg-white" data-testid="public-layout">
      {/* Navigation */}
      <header className="sticky top-0 bg-white/95 backdrop-blur-sm border-b border-slate-200 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2" data-testid="public-logo">
              <span className="text-xl font-bold text-slate-900 tracking-tight font-serif">
                Affiliate Hub
              </span>
            </Link>
            <div className="flex items-center gap-6">
              <Link
                to="/ai-video-tools"
                className={`text-sm font-medium transition-colors ${
                  location.pathname.includes("ai-video-tools")
                    ? "text-blue-600"
                    : "text-slate-600 hover:text-slate-900"
                }`}
                data-testid="nav-ai-video-tools"
              >
                AI Video Tools
              </Link>
              <Link
                to="/admin"
                className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700 transition-colors"
                data-testid="admin-link"
              >
                <Settings size={16} />
                Admin
              </Link>
            </div>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-bold text-slate-900 font-serif text-lg">
                Affiliate Hub
              </h3>
              <p className="text-slate-600 text-sm mt-2 leading-relaxed">
                Your trusted source for honest software reviews and comparisons.
                We help you find the best tools for your needs.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-slate-900 mb-3">Categories</h4>
              <ul className="space-y-2 text-sm text-slate-600">
                <li>
                  <Link to="/ai-video-tools" className="hover:text-blue-600">
                    AI Video Tools
                  </Link>
                </li>
                <li>
                  <span className="text-slate-400">SEO Software (Coming Soon)</span>
                </li>
                <li>
                  <span className="text-slate-400">E-commerce Platforms (Coming Soon)</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-slate-900 mb-3">Disclosure</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                We may earn affiliate commissions from purchases made through
                links on this site. This doesn't affect our editorial
                independence or review integrity.
              </p>
            </div>
          </div>
          <div className="border-t border-slate-200 mt-8 pt-8 text-center text-sm text-slate-500">
            © {new Date().getFullYear()} Affiliate Hub. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
